import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import SelfAvatar from './SelfAvatar';
import Avatar from './Avatar';

const ChatMessageStreamHeader = ({ contact, text, className, ...props }) => {
  const cn = useClassNames(
    () => ['items-center', 'text-center', 'max-w-line-length', 'py-8', 'mx-auto', className],
    [className],
  );
  const initials = contact.firstName ? `${contact.firstName[0]}${contact.lastName[0]}` : null;
  return (
    <header data-component="ChatMessageStreamHeader" className={cn} {...props}>
      <Avatar
        src={contact.isSelf ? <SelfAvatar size="20" /> : contact.avatar}
        initials={initials}
        alt={contact.fullNameWithTitle}
        size="32"
        className="mx-auto"
        isBlock
      />
      <h1 className="text-2xl font-semibold mt-8 mb-3">{contact.fullNameWithTitle}</h1>
      {text && <div>{text}</div>}
    </header>
  );
};

ChatMessageStreamHeader.propTypes = {
  contact: PropTypes.shape({
    isSelf: PropTypes.bool,
    avatar: PropTypes.string,
    title: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    fullNameWithTitle: PropTypes.string,
  }),
  text: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ChatMessageStreamHeader;
